import { createSlice } from "redux-starter-kit";
import QueryString from "query-string";
import { getKeywordOrTitle } from "lib/routing";

export const headerSlice = createSlice({
  slice: "header",
  initialState: { isSearchBarVisible: false },
  reducers: {
    toggleSearchBar: (state) => {
      state.isSearchBarVisible = !state.isSearchBarVisible;
    },
  },
  extraReducers: {
    "@@router/LOCATION_CHANGE": (state, action) => {
      const qs = QueryString.parse(action.payload.location.search);
      if (getKeywordOrTitle(qs)) state.isSearchBarVisible = true;
    },
  },
});
